export const LiveRegionIds = {
  Log: 'live-region-log',
  Status: 'live-region-status',
  Alert: 'live-region-alert',
};
